import {Worksheet} from "exceljs";

import {GenerateExportExcelHeadColumnStylesCb, GenerateExportExcelRowStylesCb} from "@ui/tableCustom/types/table";
import {IExportDataSetItem} from "@containers/export/containers/buildData/hooks/types/exportParams";

import {generateStylesHeadColumnsExcelJs} from '../styles/generateStylesExcelJs'
import {addYSteps} from "./helpers/calcDataSetRowsIndex";
import {buildHeaderColumns} from "./buildHeaderColumns";
import {buildRowData} from "./buildRowData";

export const buildExcelData = <T>({
                                      dataSetRowIndex,
                                      worksheet,
                                      excelData,
                                      generateExportExcelRowStylesCb,
                                      generateExportExcelHeadColumnStylesCb,
                                  }: {
    dataSetRowIndex: number,
    worksheet: Worksheet,
    excelData: IExportDataSetItem,
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>,
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb
}) => {
    const {
        data,
        columns,
        headColumns,
        ySteps,
    } = excelData;


    buildHeaderColumns({
        worksheet,
        columns,
        headColumns,
        generateExportExcelHeadColumnStylesCb,
        dataSetRowIndex,

    })
    generateStylesHeadColumnsExcelJs({
        columns,
        worksheet,
        disableChangeWidthSizeColumn:excelData?.settings?.disableChangeWidthSizeColumn
    })

    buildRowData<T>({
        worksheet,
        data,
        columns,
        generateExportExcelRowStylesCb,
    })

    if (ySteps > 0) {
        addYSteps({
            worksheet,
            ySteps,
        })
    }


}